<template>
  <CModal
    :title="$pgettext('collaborators.export_ftp', 'Export FTP')"
    :show="show"
    @update:show="close"
    size="lg"
    centered
  >
    <template v-if="show">
      <PFRow :label="$pgettext('collaborators.export_ftp', 'Type')" size="12x12">
        <CSelect v-model="form.type" :options="typeOptions" @change="onTypeChange"/>
      </PFRow>

      <PFRow
        v-if="form.type === 'gallery' && scopeType === 'pica-service'"
        :label="$pgettext('collaborators.export_ftp', 'Gallery')"
        size="12x12"
      >
        <multiselect
          v-model="selectedGallery"
          :placeholder="$pgettext('collaborators.export_ftp', 'Select Gallery')"
          label="name"
          track-by="id"
          :options="flattenedGalleries"
          @input="onGallerySet"
        >
          <template #option="props">
            <div class="option__desc">
              <span>{{ props.option.name }}</span>
            </div>
          </template>
        </multiselect>
      </PFRow>
    </template>

    <template #footer>
      <CButton @click="close" color="secondary" v-translate>Close</CButton>
      <PButton
        @click="onExport"
        color="primary"
        :disabled="v$.$invalid"
        translate-context="collaborators.export_ftp"
      >
        <translate translate-context="collaborators.export_ftp">Export</translate>
      </PButton>
    </template>
  </CModal>
</template>

<script>
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapActions, mapGetters} from "vuex";
import PButton from "@/components/PButton.vue";
import PFRow from "@/domain/core/components/PFRow.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "ExportFtpModal",

  components: {
    PFRow,
    PButton,
    Multiselect
  },

  props: {
    scopeType: {
      type: String,
      required: true,
      validator: v => ['global', 'contract-manager', 'pica-service'].includes(v)
    }
  },

  data() {
    return {
      form: {
        type: null,
        gallery_id: null
      },
      selectedGallery: null,
      show: false
    }
  },

  computed: {
    ...mapGetters('eventGallery', [
      'galleries',
    ]),

    typeOptions() {
      // Contract Manager: solo Global
      if (this.scopeType === 'contract-manager') {
        return [
          {value: 'global', label: 'Global'}
        ];
      }

      // Pica Service: Global, Pica Service, Gallery
      return [
        {value: 'global', label: 'Global'},
        {value: 'pica_service', label: 'Pica Service'},
        {value: 'gallery', label: 'Gallery'}
      ];
    },

    flattenedGalleries() {
      const flatten = (galleries, parentName = '') => {
        let result = [];
        galleries.forEach(gallery => {
          const galleryName = parentName ? `${parentName} - ${gallery.name}` : gallery.name;
          result.push({
            ...gallery,
            name: galleryName
          });
          if (gallery.sub && gallery.sub.length > 0) {
            result = result.concat(flatten(gallery.sub, galleryName));
          }
        });
        return result;
      };
      return flatten(this.galleries);
    }
  },

  setup() {
    return {v$: useVuelidate()}
  },

  validations() {
    return {
      form: {
        type: {required},
        gallery_id: {
          required: (value) => {
            // Gallery ID richiesto solo se type è 'gallery' e siamo in pica-service
            return this.form.type !== 'gallery' ||
                   this.scopeType !== 'pica-service' ||
                   value !== null;
          }
        }
      }
    }
  },

  methods: {
    ...mapActions('collaborators', [
      'exportFtpCredentials',
    ]),

    open() {
      // Default: Global per Contract Manager, Pica Service per Pica Service
      this.form.type = this.scopeType === 'contract-manager' ? 'global' : 'pica_service';
      this.form.gallery_id = null;
      this.selectedGallery = null;
      this.show = true;
    },

    async onExport() {
      try {
        await this.exportFtpCredentials({
          type: this.form.type,
          gallery_id: this.form.gallery_id
        });
        this.close();
      } catch (error) {
        // L'errore viene gestito dal service/store
        console.error('Export FTP failed:', error);
      }
    },

    close() {
      this.show = false;
    },

    onTypeChange() {
      // Reset gallery selection quando cambia il tipo
      if (this.form.type !== 'gallery') {
        this.form.gallery_id = null;
        this.selectedGallery = null;
      }
    },

    onGallerySet(value) {
      this.selectedGallery = value;
      this.form.gallery_id = value?.id || null;
    }
  }
}
</script>

<style scoped>
.option__desc {
  padding: 8px;
}
</style>
